export class BaseMenu {
    constructor(table) {
        this._table = table;
    }
    release() {
        this.unbindMenuElement(), this._menuElement && this._menuElement.release(), this._menuElement = void 0;
    }
    _getMenuElement() {
        return this._menuElement || (this._menuElement = this.createMenuElementInternal()), 
        this._menuElement;
    }
    bindMenuElement(col, row, menuInstanceInfo) {
        return this._getMenuElement().bindToCell(this._table, col, row, menuInstanceInfo);
    }
    unbindMenuElement() {
        this._getMenuElement().unbindFromCell();
    }
    pointInMenuElement(x, y) {
        return this._getMenuElement().pointInMenuElement(x, y);
    }
    getRootElement() {
        return this._getMenuElement().rootElement;
    }
}
//# sourceMappingURL=BaseMenu.js.map
